import Capture from './capture';

export default Capture;
